"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require("semantic-ui-react");

var _reactRouterDom = require("react-router-dom");

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

var _FixedMenuLayout = require("../../layouts/FixedMenuLayout");

var _FixedMenuLayout2 = _interopRequireDefault(_FixedMenuLayout);

var _constants = require("../../utils/constants");

var Constants = _interopRequireWildcard(_constants);

var _universalCookie = require("universal-cookie");

var _universalCookie2 = _interopRequireDefault(_universalCookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //      


var Login = function (_Component) {
	_inherits(Login, _Component);

	function Login() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Login);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Login.__proto__ || Object.getPrototypeOf(Login)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			username: "",
			password: "",
			organization: "",
			redirectToReferrer: false,
			axios: {},
			header: {},
			showErrorMsg: false,
			ErrorMsg: "",
			isAuth: false
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Login, [{
		key: "successLogin",
		value: function successLogin(response) {

			if (response.status === "OK") {

				var header = { "Authorization": "Bearer " + response.token };
				var cookies = new _universalCookie2.default();
				cookies.set("myToken", response.token, { path: "/", expires: new Date(Date.now() + 3600000) });

				var orga = "";
				if (response.organization == Constants.ORGA_TV3) {
					orga = Constants.ORGA_TV3;
				} else if (response.organization == Constants.ORGA_SMC) {
					orga = Constants.ORGA_SMC;
				} else if (response.organization == Constants.ORGA_ICGC) {
					orga = Constants.ORGA_ICGC;
				} else {
					orga = Constants.ORGA_ICGC;
				}
				cookies.set("myOrganization", orga, { path: "/", expires: new Date(Date.now() + 3600000) });
				this.setState({ redirectToReferrer: true, header: header, token: response.token, isAuth: true, organization: orga });
			} else {

				this.setState({ showErrorMsg: true });
			}
			//	this.setState({ redirectToReferrer: true, isAuth: true, header:{"Authorization": true}});
			return;
		}
	}, {
		key: "doLogin",
		value: function doLogin() {
			var _this2 = this;

			var _state = this.state,
			    username = _state.username,
			    password = _state.password;

			//console.log("user", username);

			_request2.default.post(Constants.doLogin, { username: username, password: password }).then(this.successLogin.bind(this)).catch(function (error) {
				//	console.log(error);
				_this2.setState({ showErrorMsg: true, ErrorMsg: error });
			});
		}
	}, {
		key: "renderError",
		value: function renderError() {

			if (this.state.showErrorMsg) {

				return _react2.default.createElement(
					_semanticUiReact.Message,
					{ negative: true },
					_react2.default.createElement(
						_semanticUiReact.Message.Header,
						null,
						"Usuari i/o password incorrectes"
					),
					_react2.default.createElement(
						"p",
						null,
						this.state.ErrorMsg
					)
				);
			} else {

				return _react2.default.createElement("div", null);
			}
		}
	}, {
		key: "renderLoginForm",
		value: function renderLoginForm() {
			var _this3 = this;

			return _react2.default.createElement(
				_semanticUiReact.Grid,
				{ textAlign: "center", style: { height: "100vh" }, verticalAlign: "middle" },
				_react2.default.createElement(
					_semanticUiReact.Grid.Column,
					{ style: { maxWidth: 450 } },
					_react2.default.createElement(_semanticUiReact.Header, { as: "h2", color: "teal", textAlign: "center" }),
					_react2.default.createElement(
						_semanticUiReact.Form,
						{ size: "large" },
						_react2.default.createElement(
							_semanticUiReact.Segment,
							{ stacked: true },
							_react2.default.createElement(_semanticUiReact.Form.Input, { fluid: true, icon: "user", iconPosition: "left", placeholder: "username",
								onChange: function onChange(evt) {
									return _this3.setState({ username: evt.target.value });
								},
								value: this.state.username,
								defaulvalue: ""
							}),
							_react2.default.createElement(_semanticUiReact.Form.Input, {
								fluid: true,
								icon: "lock",
								iconPosition: "left",
								placeholder: "Password",
								type: "password",
								onChange: function onChange(evt) {
									return _this3.setState({ password: evt.target.value });
								},
								defaulvalue: "",
								value: this.state.password
							}),
							_react2.default.createElement(
								_semanticUiReact.Button,
								{ onClick: this.doLogin.bind(this), color: "teal", fluid: true, size: "large" },
								"Entrar"
							)
						)
					),
					this.renderError()
				)
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _state2 = this.state,
			    redirectToReferrer = _state2.redirectToReferrer,
			    token = _state2.token,
			    header = _state2.header,
			    organization = _state2.organization;
			// eslint-disable-next-line react/prop-types
			// eslint-disable-next-line react/prop-types
			//const origin = this.props.location.origin || "gestor";

			var origin = "gestor";

			//pathname: `/${origin}`,
			if (redirectToReferrer) {

				return _react2.default.createElement(_reactRouterDom.Redirect, { to: {
						pathname: "/" + origin,
						state: { header: header, isAuth: true, organization: organization },
						header: token
					} });
			}

			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_FixedMenuLayout2.default, { title: "Autentificaci\xF3",
					isVisor: true,
					organization: this.state.organization
				}),
				this.renderLoginForm()
			);
		}
	}]);

	return Login;
}(_react.Component);

exports.default = Login;
